import React from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Box, Modal } from "@mui/material";
import { AppointmentsAPI } from "../../middleware";
import { TiArrowLeft } from "react-icons/ti";

type CancelAppointmentDialogProps = {
  open: boolean;
  onClose: () => void;
  appointmentId: string;
  accessToken: string;
  onCancelSuccess: () => void;
  onCancelError: () => void; // Ensure this line is present
  healthFacilityId: string;
  patientId: string;
  setIsLoading: (loading: boolean) => void; // Add this line
};

const CancelAppointmentDialog: React.FC<CancelAppointmentDialogProps> = ({
  open,
  onClose,
  appointmentId,
  accessToken,
  onCancelSuccess,
  onCancelError, // Ensure this line is present
  healthFacilityId,
  patientId,
  setIsLoading, // Destructure the new prop
}) => {
  const handleCancel = async () => {
    setIsLoading(true); // Set loading to true when starting the cancel process
    onClose(); // Close dialog
    try {
      const response = await AppointmentsAPI.cancelAppointment(accessToken, healthFacilityId, patientId, appointmentId);
      if (response.status === 200 || response.status === 201) {
        onCancelSuccess(); // Notify success
      } else {
        onCancelError(); // Notify error
      }
    } catch (error) {
      console.error("Error canceling appointment:", error);
      onCancelError(); // Notify error
    } finally {
      setIsLoading(false); // Reset loading state
    }
  };

  return (

    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          // width: "md:90vw ",
          // height: 500,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          textAlign: "center",
          scrollbarColor: "#000",
          overflowY: "scroll",
          bgcolor: "background.paper",
          border: "2px solid #000",
          boxShadow: 24,
          p: 4,
        }}
        className="md:w-[400px] w-10/12"
      >
        <div
          className="flex items-center space-x-2 text-primary-100 text-xl cursor-pointer py-0"
          onClick={() => {
            // setSelectedAppointmentCategoryType(null);
            // setShowConfirmModal(false);
            // setIsModalOpen(true);
          }}
        >
          <React.Fragment>
            <TiArrowLeft className="text-primary-100 text-2xl" />
          </React.Fragment>
        </div>

        <h3 className="text-center">Cancel Appointment</h3>
        <p className="py-3">
          This action cannot be undone

        </p>
        <div className="flex flex-row justify-between ">
          <button
            // onClick={handleConfirm}
            onClick={() => {
              localStorage.setItem("view", "Appointments");
              onClose();

            }}
            className="bg-primary-100 hover:opacity-70 text-white py-2 px-8 rounded-3xl transition-all duration-300 ease-in-out"
          >
            Cancel
          </button>
          <button
            // onClick={handleConfirm}
            onClick={() => {
              localStorage.setItem("view", "Appointments");
              handleCancel();

              // setShowConfirmModal(false);
              // // book appointment
              // handleConfirm();

            }}
            className="bg-primary-100 hover:opacity-70 text-white py-2 px-8 rounded-3xl transition-all duration-300 ease-in-out"
          >
            Confirm
          </button>
        </div>
      </Box>
    </Modal>
  );
};

export default CancelAppointmentDialog;